export const writeJSON = <S>(o: S, defaultValue: S = {} as S) => {
  o = o ?? defaultValue;

  if (typeof o === 'string') {
    return o;
  }

  return JSON.stringify(o, null, 2);
};

export type TADT<S> = Record<string, S> | S[];

/**
 * read a json string and parse out the comments
 */
export function readJSON<S>(_s: string): TADT<S>;
export function readJSON<S>(_s: null | undefined | S): S;
export function readJSON<S>(_s: null | undefined | string | S, defaultValue: S = {} as S): TADT<S> | S {
  _s = _s ?? defaultValue;

  if (typeof _s !== 'string') {
    return _s;
  }

  try {
    return JSON.parse(`${_s || '{}'}`);
  } catch {
    return {};
  }
}
